// Author thq
// Date 2024-02-20 19:40:42

class TpmMonitorOperateModeTmo {
    constructor({
                    id = null,
                    nodeId = '',
                    tmoCodeBda = '',
                    tmoStatus = '',
                    tmoBeginTime = '',
                    tmoEndTime = '',
                    tmoDurationTime = '',
                    tmoStartValue = '',
                    tmoEndValue = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.nodeId = nodeId;
        this.tmoCodeBda = tmoCodeBda;
        this.tmoStatus = tmoStatus;
        this.tmoBeginTime = tmoBeginTime;
        this.tmoEndTime = tmoEndTime;
        this.tmoDurationTime = tmoDurationTime;
        this.tmoStartValue = tmoStartValue;
        this.tmoEndValue = tmoEndValue;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmMonitorOperateModeTmo();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeId',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.nodeId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoCodeBda',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoStatus',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoStatus',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoBeginTime',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoEndTime',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoDurationTime',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoDurationTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoStartValue',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoStartValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmoEndValue',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.tmoEndValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nodeIdFilter: '',
    tmoCodeBdaFilter: '',
    tmoStatusFilter: '',
    tmoBeginTimeRteFilter: '',
    tmoBeginTimeLteFilter: '',
    tmoEndTimeRteFilter: '',
    tmoEndTimeLteFilter: '',
    tmoEndTimeIsNullFilter: '',
    tmoEndTimeRteQueryStartTimeFilter: '',
    tmoBeginTimeLteQueryEndTimeFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nodeIdFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.nodeId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoCodeBdaFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStatusFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoStatus',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoBeginTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoBeginTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.filter.tmoEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'nodeId',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.nodeId',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoCodeBda',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStatus',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoBeginTime',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndTime',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoDurationTime',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoDurationTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoStartValue',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoStartValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmoEndValue',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.tmoEndValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmMonitorOperateModeTmo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmMonitorOperateModeTmo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
